import React from 'react'
import Loader from './loader'
import { useAuth } from 'context/auth'

function CDButton({ disabled, processing, label, type, className, ...rest }) {
  const {currentUser} = useAuth()
  const pri_btn_bg_color = currentUser?.account?.branding?.buttonBackgroundColor
  const btn_text_color = currentUser?.account?.branding?.buttonTextColor

  // Guard against invisible labels: if the brand's button text and background
  // colours are the same (older accounts defaulted both to #1D2D58), drop the
  // inline colours and fall back to the visible .btn default (ember / white).
  const sameColor =
    pri_btn_bg_color &&
    btn_text_color &&
    pri_btn_bg_color.toLowerCase() === btn_text_color.toLowerCase()
  const brandStyle = sameColor
    ? {}
    : { backgroundColor: pri_btn_bg_color, color: btn_text_color }

  return (
    <button
      type={type || 'submit'}
      disabled={disabled || processing}
      className={`btn ${disabled || processing ? 'disable' : ''} ${className}`}
      style={brandStyle}
      {...rest}
    >
      {processing ? <Loader /> : label}
    </button>
  )
}

export default CDButton
